import {navigationRef} from '@utils';

export const HOME_ROUTE_NAME = 'Home';
export const HOME_ROUTE_PATH = '/index/home';

/** 破产补助轮询仅在首页、三方/体育(/webview)、游戏 WebView、Dice、Color、Scratch 发起请求。 */
const BANKRUPTCY_POLL_PATHS = new Set([
  HOME_ROUTE_PATH,
  '/webview',
  '/game-webview',
  '/dice',
  '/color',
  '/scratch',
]);

const BANKRUPTCY_POLL_ROUTE_NAMES = new Set([
  HOME_ROUTE_NAME,
  'WebView',
  'GameWebView',
  'Dice',
  'Color',
  'Scratch',
]);

function getCurrentPathname() {
  if (typeof location === 'undefined') {
    return '';
  }
  return location.pathname.replace(/\/+$/, '') || '/';
}

export function isHomeRoute() {
  if (getCurrentPathname() !== HOME_ROUTE_PATH) {
    return false;
  }

  return (
    !navigationRef.isReady() ||
    navigationRef.getCurrentRoute()?.name === HOME_ROUTE_NAME
  );
}

export function shouldCheckBankruptcySubsidyPopup(currentRouteName?: string) {
  const pathname = getCurrentPathname();
  if (pathname && BANKRUPTCY_POLL_PATHS.has(pathname)) {
    return true;
  }
  const routeName =
    currentRouteName ||
    (navigationRef.isReady()
      ? navigationRef.getCurrentRoute()?.name
      : undefined);
  return !!routeName && BANKRUPTCY_POLL_ROUTE_NAMES.has(routeName);
}

let homeSequentialReady = false;
let lastVisitWasHome: boolean | null = null;

/**
 * 进入或离开首页时关掉轮询接管。
 * 回到首页后要等这一轮顺序弹窗结束，破产补助才能单独弹，避免先占住弹层。
 */
export function syncHomeSequentialVisit() {
  const home = isHomeRoute();
  if (lastVisitWasHome === null) {
    lastVisitWasHome = home;
    return;
  }
  if (lastVisitWasHome !== home) {
    homeSequentialReady = false;
    lastVisitWasHome = home;
  }
}

/** 首页首次顺序弹窗检测完成后才允许轮询接管，避免抢首屏队列。 */
export function setHomeSequentialReady(ready: boolean) {
  homeSequentialReady = ready;
  if (ready && isHomeRoute()) {
    lastVisitWasHome = true;
  }
}

export function isHomeSequentialReady() {
  return homeSequentialReady;
}
